import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/auth/Login";
import Layout from "../components/layout/Layout";
import DashboardLayout from "../pages/dashboard/DashboardLayout";
import HeroPage from "../pages/dashboard/HeroPage";
import NewFormPage from "../pages/dashboard/NewFormPage";
// import PrivateRoute from "./PrivateRoute"; // Keep commented for now
import NotFound from "../pages/NotFound";
import TrackGrievance from "../pages/grievance/TrackGrievance";
import SubmitGrievance from "../pages/grievance/SubmitGrievance";
import NewsDetails from "../components/news/NewsDetails";
import CdmpPage from "../pages/cdmp/CdmpPage";
import OverviewPage from "../pages/OverviewPage/OverviewPage";
import FaqPage from "../components/shared/FaqPage/FaqPage";
import ScrollToTop from "../components/common/ScrollToTop";
import DocumentDetail from "../components/common/DocumentDetail";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions/TermsConditions";
import Sitemap from "../pages/siteMap/sitemap";

// Temporary wrapper to bypass authentication (since your working version uses this)
const PublicWrapper = ({ children }) => {
  console.log('PublicWrapper: Rendering without authentication');
  return children;
};

const AppRoutes = () => (
  <>
    <ScrollToTop />
    <Routes>
      {/* 🔓 PUBLIC ROUTES */}
      <Route path="/login" element={<Login />} />
      <Route path="/cdmp/:section/:docSlug" element={<DocumentDetail />} />

      {/* 🏠 MAIN DASHBOARD AT ROOT PATH */}
      <Route
        path="/"
        element={
          <PublicWrapper>
            <Layout />
          </PublicWrapper>
        }
      >
        <Route index element={<HeroPage />} />
        <Route path="new-form" element={<NewFormPage />} />
        <Route path="overview" element={<OverviewPage />} />
        <Route path="news" element={<NewsDetails />} />
        <Route path="news/:newsId" element={<NewsDetails />} />

        <Route element={<DashboardLayout />}>
          <Route path="cdmp/:section" element={<CdmpPage />} />
          <Route path="info/:section" element={<FaqPage />} />
        </Route>

        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-conditions" element={<TermsConditions />} />
        <Route path="sitemap" element={<Sitemap />} />

        <Route path="grievance">
          <Route path="submit" element={<SubmitGrievance />} />
          <Route path="track" element={<TrackGrievance />} />
        </Route>
      </Route>

      {/* 🔄 REDIRECT /dashboard TO ROOT */}
      <Route path="/dashboard" element={<Navigate to="/" replace />} />
      <Route path="/dashboard/*" element={<Navigate to="/" replace />} />

      {/* ❌ 404 - UNCOMMENT THIS */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </>
);

export default AppRoutes;

// import { Routes, Route } from "react-router-dom";
// import Login from "../pages/auth/Login";
// import Layout from "../components/layout/Layout";
// import DashboardLayout from "../pages/dashboard/DashboardLayout";
// import HeroPage from "../pages/dashboard/HeroPage";
// import NewFormPage from "../pages/dashboard/NewFormPage";
// import PrivateRoute from "./PrivateRoute";
// import NotFound from "../pages/NotFound";
// import TrackGrievance from "../pages/grievance/TrackGrievance";
// import SubmitGrievance from "../pages/grievance/SubmitGrievance";
// import NewsDetails from "../components/news/NewsDetails";
// import CdmpPage from "../pages/cdmp/CdmpPage";
// import OverviewPage from "../pages/OverviewPage/OverviewPage";
// import FaqPage from "../components/shared/FaqPage/FaqPage";
// import ScrollToTop from "../components/common/ScrollToTop";
// import DocumentDetail from "../components/common/DocumentDetail";
// import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
// import TermsConditions from "../pages/TermsConditions/TermsConditions";
// import Sitemap from "../pages/siteMap/sitemap";

// const AppRoutes = () => (
//   <>
//     <ScrollToTop />
//     <Routes>
//       <Route path="/login" element={<Login />} />
//       <Route path="/cdmp/:section/:docSlug" element={<DocumentDetail />} />

//       <Route
//         path="/"
//         element={
//           <PrivateRoute>
//             <Layout />
//           </PrivateRoute>
//         }
//       >
//         <Route path="/news" element={<NewsDetails />} />
//         <Route path="news/:newsId" element={<NewsDetails />} />
//         <Route path="/overview" element={<OverviewPage />} />

//         {/* Dashboard Routes */}
//         <Route element={<DashboardLayout />}>
//           <Route index element={<HeroPage />} />
//           <Route path="new-form" element={<NewFormPage />} />

//           <Route path="cdmp/:section" element={<CdmpPage />} />
//           <Route path="/info/:section" element={<FaqPage />} />
//           {/* add more dashboard pages here */}
//         </Route>
//         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//         <Route path="/terms-conditions" element={<TermsConditions />} />

//         <Route path="/sitemap" element={<Sitemap />} />

//         <Route path="grievance">
//           <Route path="submit" element={<SubmitGrievance />} />
//           <Route path="track" element={<TrackGrievance />} />
//         </Route>
//       </Route>

//       <Route path="*" element={<NotFound />} />
//     </Routes>
//   </>
// );

// export default AppRoutes;
